export default {
    getDocuments: state => state.documents,
    getDocumentCategories: state => state.documentCategories,
    getFilter: state => state.filter,
    getUploadDocuments: state => state.uploadDocuments,
    foldersValidation: state => state.validationErrors
}